import { type FC } from "react";
import { useTranslation } from "react-i18next";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { formatAmountObject } from "@/partner/features/products";
import {
  buildPaymentBreakdownRows,
  type BreakdownPayment,
} from "../model/paymentBreakdown";

export const PaymentBreakdown: FC<{ payment: BreakdownPayment }> = ({
  payment,
}) => {
  const { t } = useTranslation();
  const emptyValue = t("common.emptyDash");
  const rows = buildPaymentBreakdownRows(payment);

  return (
    <Table size="small">
      <TableBody>
        {rows.map((row) => {
          const fontWeight = row.strong ? 600 : 400;
          // Сумму в валюте организации показываем только когда валюта
          // отличается от валюты платежа: иначе это то же самое число.
          const showOrganizationAmount =
            row.organizationAmount != null &&
            row.organizationAmount.currency !== row.amount?.currency;

          return (
            <TableRow key={row.key}>
              <TableCell sx={{ fontWeight, border: 0, pl: 0 }}>
                {t(`purchases.details.${row.key}`)}
              </TableCell>
              <TableCell
                align="right"
                sx={{ fontWeight, border: 0, pr: 0, whiteSpace: "nowrap" }}
              >
                {formatAmountObject(row.amount, emptyValue)}
                {showOrganizationAmount && (
                  <Typography
                    component="span"
                    variant="body2"
                    color="text.secondary"
                    sx={{ ml: 1 }}
                  >
                    ({formatAmountObject(row.organizationAmount, emptyValue)})
                  </Typography>
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
